(() => {
  if (window.__atvVariantGalleryBound) return;
  window.__atvVariantGalleryBound = true;

  const SRC_WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000];

  function srcForWidth(src, width) {
    if (!src) return '';
    if (/width=\d+/.test(src)) return src.replace(/width=\d+/, 'width=' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcsetFor(src) {
    return SRC_WIDTHS.map((width) => srcForWidth(src, width) + ' ' + width + 'w').join(', ');
  }

  function escapeAttr(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function parseJSON(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.variantGalleryReady === 'true') return;
    gallery.dataset.variantGalleryReady = 'true';

    const map = parseJSON(gallery.querySelector('[data-variant-gallery-map]'));
    const fallbackSlides = gallery.querySelector('[data-product-gallery-fallback]');
    const fallbackThumbs = gallery.querySelector('[data-product-gallery-fallback-thumbs]');
    const zoomTemplate = gallery.querySelector('[data-variant-gallery-zoom]');

    const list = gallery.querySelector('.product__media-list');
    const dots = gallery.querySelector('media-dots');

    gallery._variantGallery = {
      map: map || {},
      fallbackSlides: (fallbackSlides && fallbackSlides.innerHTML) || (list ? list.innerHTML : ''),
      fallbackThumbs: (fallbackThumbs && fallbackThumbs.innerHTML) || (dots ? dots.innerHTML : ''),
      zoomHTML: zoomTemplate ? zoomTemplate.innerHTML.trim() : '',
      sizes: gallery.getAttribute('data-sizes') || '(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(580px, 30vw)',
      ratio: gallery.getAttribute('data-image-ratio') || 'adapt',
      ratioMobile: gallery.getAttribute('data-image-ratio-mobile') || 'adapt',
      galleryLayout: gallery.getAttribute('data-gallery-layout') || 'thumbnail'
    };

    if (dots && dots.dataset.variantGalleryClicks !== 'true') {
      dots.dataset.variantGalleryClicks = 'true';
      dots.addEventListener('click', (event) => {
        const button = event.target.closest('[data-media-id]');
        if (!button || !dots.contains(button)) return;
        if (typeof dots.onButtonClick === 'function') {
          dots.onButtonClick({
            preventDefault() { event.preventDefault(); },
            currentTarget: button
          });
        }
      });
    }
  }

  function slideHTML(image, index, config) {
    const loading = index === 0 ? 'eager' : 'lazy';
    const fetchpriority = index === 0 ? 'high' : 'auto';
    const hideOnDesktop = config.galleryLayout === 'scroll' && index === 0;
    const classes = [
      'product__media card media',
      'media--' + config.ratio,
      'mobile:media--' + config.ratioMobile,
      'flex w-full flex-auto relative overflow-hidden'
    ];
    if (hideOnDesktop) classes.push('xl:hidden');

    return (
      '<div class="' + classes.join(' ') + '" data-media-type="image" data-media-id="' + escapeAttr(image.id) + '" data-variant-file data-gang-default>' +
        '<img src="' + escapeAttr(srcForWidth(image.src, 1200)) + '"' +
          ' srcset="' + escapeAttr(srcsetFor(image.src)) + '"' +
          ' sizes="' + escapeAttr(config.sizes) + '"' +
          ' width="' + escapeAttr(image.width || 1600) + '"' +
          ' height="' + escapeAttr(image.height || 1600) + '"' +
          ' alt="' + escapeAttr(image.alt) + '"' +
          ' class="w-full" loading="' + loading + '" fetchpriority="' + fetchpriority + '" is="lazy-image">' +
        (config.zoomHTML || '') +
      '</div>'
    );
  }

  function thumbHTML(image, index) {
    return (
      '<button type="button" class="product__thumbnail media media--square relative overflow-hidden"' +
        ' data-media-id="' + escapeAttr(image.id) + '"' +
        ' data-index="' + (index + 1) + '"' +
        ' aria-label="Go to item ' + (index + 1) + '"' +
        ' aria-current="' + (index === 0 ? 'true' : 'false') + '"' +
        ' data-gang-default>' +
        '<img src="' + escapeAttr(image.thumb || srcForWidth(image.src, 416)) + '"' +
          ' alt="' + escapeAttr(image.alt) + '"' +
          ' width="104" height="104" loading="lazy"' +
          ' sizes="(max-width: 1280px) 90px, 98px" is="lazy-image">' +
      '</button>'
    );
  }

  function resetSlider(gallery) {
    const slider = gallery.sliderGallery || gallery.querySelector('slider-element');
    if (!slider) return;
    if (typeof slider.reset === 'function') slider.reset();
    slider.currentPage = 1;
    slider.scrollLeft = 0;
    if (typeof slider.updateButtons === 'function') slider.updateButtons();
  }

  function resetDots(gallery, count) {
    const dots = gallery.sliderDots || gallery.querySelector('media-dots');
    if (!dots) return;
    const wrap = dots.closest('.product__thumbnails') || dots;
    wrap.hidden = count <= 1;
    if (typeof dots.reset === 'function') dots.reset();
    if (typeof dots.resetIndexes === 'function') dots.resetIndexes();
  }

  function updatePreview(gallery) {
    const previewHost = gallery.querySelector('.product__preview');
    if (!previewHost) return;
    const list = gallery.querySelector('.product__media-list');
    const first = list && list.querySelector('.product__media');
    if (!first) return;
    const clone = first.cloneNode(true);
    clone.classList.remove('xl:hidden');
    const existing = previewHost.querySelector('.product__media');
    if (existing) existing.replaceWith(clone);
    else previewHost.appendChild(clone);
    first.classList.add('xl:hidden');
  }

  function applyVariant(gallery, variantId) {
    initGallery(gallery);
    const config = gallery._variantGallery;
    if (!config) return;

    const images = config.map[String(variantId)] || [];
    const nextKey = images.length ? 'v:' + variantId : 'fallback';
    if (gallery.dataset.galleryKey === nextKey) return;
    gallery.dataset.galleryKey = nextKey;

    const list = gallery.querySelector('.product__media-list');
    const dots = gallery.querySelector('media-dots');
    if (!list) return;

    if (images.length) {
      list.innerHTML = images.map((image, index) => slideHTML(image, index, config)).join('');
      if (dots) dots.innerHTML = images.map((image, index) => thumbHTML(image, index)).join('');
      resetSlider(gallery);
      resetDots(gallery, images.length);
    } else {
      if (config.fallbackSlides) list.innerHTML = config.fallbackSlides;
      if (dots && config.fallbackThumbs) dots.innerHTML = config.fallbackThumbs;
      const count = list.querySelectorAll('[data-media-id]').length;
      resetSlider(gallery);
      resetDots(gallery, count);
    }

    if (config.galleryLayout === 'scroll') updatePreview(gallery);
    if (typeof gallery.countMediaGallery === 'function') gallery.countMediaGallery();
  }

  function boot() {
    document.querySelectorAll('media-gallery[data-variant-gallery]').forEach(initGallery);
  }

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    document.querySelectorAll('media-gallery[data-variant-gallery]').forEach((gallery) => {
      applyVariant(gallery, variant.id);
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
